<a class="skip-link" href="#main-content">Skip to content</a>

<header class="site-header">
  <div class="page-shell site-header__inner">
    <a class="brand" [routerLink]="['/home']" aria-label="Settlement home">
      <img class="brand__logo" src="../../../assets/images/ab-data-logo.png" alt="ab DATA">
    </a>

    <nav class="site-nav" aria-label="Primary navigation">
      <a [routerLink]="['/home']">Home</a>
      <a [routerLink]="['/faqs']">FAQs</a>
      <a [routerLink]="['/court-documents']">Court Documents</a>
      <a [routerLink]="['/file-not-noticed']">File a Claim</a>
      <a [routerLink]="['/key-contacts']">Key Contacts</a>
      <a [routerLink]="['/contact']">Contact Information</a>
      <a href="tel:+18667789626">1-866-778-9626</a>
    </nav>
  </div>
</header>

<section class="legal-notice">
  <div class="page-shell">
    <p>
      This official website is maintained by the Settlement Administrator under the supervision of Class Counsel for the members of the Settlement Class<br>
      in the action titled <i>Doe, et al. v. GoodRx Holdings, Inc., et al.</i>, Case No. 4:23-cv-00501-AMO (N.D. Cal.).
    </p>
  </div>
</section>
